module.exports = __webpack_public_path__ + "img/2_1-parco-2-botanico.163fda38.png";